(function () {
  var cfg = window.CFP_CONFIG || {};
  var PROEF_CODE = cfg.discountCode || 'PROEF10';
  var SHIP_CODE = cfg.shippingDiscountCode || '';
  var DISCOUNT = cfg.discountPercent != null ? Number(cfg.discountPercent) : 10;
  var ADDON_VARIANT = cfg.addonVariantId || 0;
  var root = document.querySelector('[data-cfp-landing]');
  if (!root) return;

  var stickyBar = root.querySelector('.cfp-bar');
  if (stickyBar) {
    stickyBar.classList.add('cfp');
    document.body.appendChild(stickyBar);
  }

  var gekozen = null;
  var checkingOut = false;
  var tiles = root.querySelector('#cfp-tiles');
  var helpTile = root.querySelector('#cfp-help-tile');
  var fout = root.querySelector('#cfp-maat-err');
  var kgIn = root.querySelector('#cfp-kg');
  var kgOut = root.querySelector('#cfp-kg-out');
  var pack = root.querySelector('#cfp-pack');
  var checkoutErr = root.querySelector('#cfp-checkout-err');
  var addonBtn = root.querySelector('#cfp-addon-btn');
  var typeSwitch = root.querySelector('[data-cfp-type-switch]');

  function catalogs() { return cfg.catalogs || { luiers: [], luierbroekjes: [] }; }
  function currentType() { return root.getAttribute('data-cfp-type') || 'luiers'; }
  function maten() { var c = catalogs(); return c[currentType()] || c.luiers || []; }
  function unitLabel() { return currentType() === 'luierbroekjes' ? 'luierbroekjes' : 'luiers'; }
  function packUrl(m) { return (m && m.image) || ''; }
  function maxOf(m) { return m.max == null || m.max === '' ? Infinity : Number(m.max); }
  function euro(centen) { return '\u20AC' + (Number(centen) / 100).toFixed(2).replace('.', ','); }
  function alle(sel, fn) { document.querySelectorAll('.cfp ' + sel).forEach(fn); }
  function isShop(m) { return !!(m && m.variant); }
  function nieuw(m) { return Math.round(Number(m.prijs) * (100 - DISCOUNT) / 100); }

  function render() {
    var m = gekozen;
    alle('.cfp-tile[data-maat]', function (t) {
      t.setAttribute('aria-pressed', m && String(m.maat) === t.getAttribute('data-maat') ? 'true' : 'false');
    });
    alle('[data-cfp-empty]', function (e) { e.hidden = !!m; });
    alle('[data-cfp-chosen]', function (e) { e.hidden = !m; });
    alle('[data-cfp-checkout]', function (b) {
      if (!m) { b.textContent = 'Kies je maat'; return; }
      b.textContent = b.hasAttribute('data-cfp-kort') ? 'Afrekenen' : ('Afrekenen \u00B7 ' + euro(nieuw(m)));
    });
    if (!m) {
      if (pack) { pack.hidden = true; pack.removeAttribute('src'); }
      return;
    }
    var dagen = Math.floor(Number(m.luiers) / Number(m.perDag));
    var unit = unitLabel();
    alle('[data-cfp-old]', function (e) {
      e.hidden = false;
      e.textContent = euro(Number(m.prijs));
    });
    alle('[data-cfp-new]', function (e) { e.textContent = euro(nieuw(m)); });
    alle('[data-cfp-info]', function (e) {
      e.textContent = 'Maat ' + m.maat + ': ' + m.luiers + ' ' + unit + ', genoeg voor zo\'n ' + dagen + ' dagen';
    });
    alle('[data-cfp-bar]', function (e) {
      e.textContent = 'Maat ' + m.maat + ' \u00B7 ' + m.luiers + ' ' + unit + ' \u00B7 10% + gratis verzending';
    });
    if (pack) {
      var src = packUrl(m);
      if (src) {
        pack.src = src;
        pack.alt = 'Confy ' + unit + ' maat ' + m.maat + ', ' + m.luiers + ' stuks';
        pack.hidden = false;
      } else {
        pack.removeAttribute('src');
        pack.hidden = true;
      }
    }
  }

  function kies(maat) {
    gekozen = maten().filter(function (m) { return String(m.maat) === String(maat); })[0] || null;
    if (fout) fout.hidden = true;
    if (checkoutErr) checkoutErr.hidden = true;
    render();
  }

  function rebuildTiles() {
    if (!tiles) return;
    var list = maten();
    tiles.querySelectorAll('.cfp-tile[data-maat]').forEach(function (t) { t.remove(); });
    list.forEach(function (m) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cfp-tile';
      btn.setAttribute('data-maat', String(m.maat));
      btn.setAttribute('aria-pressed', 'false');
      var max = maxOf(m);
      var range = !isFinite(max) ? (m.min + '+ kg') : (m.min + '\u2013' + max + ' kg');
      btn.innerHTML = '<b>' + m.maat + '</b><span>' + range + '</span>';
      if (helpTile && helpTile.parentNode === tiles) tiles.insertBefore(btn, helpTile);
      else tiles.appendChild(btn);
    });
    schrijfTabel();
  }

  function schrijfTabel() {
    var ul = root.querySelector('.cfp-sizes');
    if (!ul) return;
    ul.innerHTML = maten().map(function (m) {
      var max = maxOf(m);
      var range = !isFinite(max) ? ('vanaf ' + m.min + ' kg') : (m.min + '\u2013' + max + ' kg');
      return '<li><b>Maat ' + m.maat + '</b>' + range + '</li>';
    }).join('');
  }

  if (tiles) {
    tiles.addEventListener('click', function (e) {
      var t = e.target.closest('.cfp-tile[data-maat]');
      if (t) { kies(t.getAttribute('data-maat')); toonAdvies(); }
    });
  }
  if (helpTile && kgIn) {
    helpTile.addEventListener('click', function () {
      kgIn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      kgIn.focus({ preventScroll: true });
    });
  }

  function adviseer(kg) {
    var past = maten().filter(function (m) { return kg >= Number(m.min) && kg <= maxOf(m); });
    if (!past.length) return null;
    var beste = past.filter(function (m) { return kg <= maxOf(m) - 1; })[0] || past[past.length - 1];
    return { beste: beste, ook: past.filter(function (m) { return m !== beste; }) };
  }

  function toonAdvies() {
    if (!kgOut || !kgIn) return;
    var tekst = kgIn.value.trim().replace(',', '.');
    if (!tekst) { kgOut.hidden = true; return; }
    kgOut.hidden = false;
    var kg = parseFloat(tekst);
    var a = isNaN(kg) ? null : adviseer(kg);
    if (!a) {
      kgOut.textContent = 'Daar hebben we geen maat voor in de tabel. Stuur ons gerust een berichtje, dan denken we met je mee.';
      return;
    }
    var html = '<b>Maat ' + a.beste.maat + ' past het best.</b> ';
    var ook = a.ook.map(function (m) { return m.maat; }).join(' en ');
    if (a.ook.length === 1) html += 'Maat ' + ook + ' past ook. ';
    if (a.ook.length > 1) html += 'De maten ' + ook + ' passen ook. ';
    if (!gekozen || String(gekozen.maat) !== String(a.beste.maat)) {
      html += '<button type="button" class="cfp-link-btn" data-cfp-kies="' + a.beste.maat + '">Kies maat ' + a.beste.maat + '</button>';
    }
    kgOut.innerHTML = html;
  }
  if (kgIn) kgIn.addEventListener('input', toonAdvies);
  if (kgOut) {
    kgOut.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cfp-kies]');
      if (b) { kies(b.getAttribute('data-cfp-kies')); toonAdvies(); }
    });
  }

  function shopRoot() {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return rootUrl.replace(/\/?$/, '/');
  }

  function addToCart(id) {
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); });
  }

  function applyDiscount(code) {
    return fetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { if (!r.ok) throw new Error('discount failed'); });
  }

  function focusMaat() {
    if (fout) fout.hidden = false;
    if (tiles) {
      tiles.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = tiles.querySelector('.cfp-tile');
      if (first) first.focus({ preventScroll: true });
    }
  }

  function onCheckout() {
    if (checkingOut) return;
    if (!gekozen) { focusMaat(); return; }
    if (!isShop(gekozen)) {
      if (checkoutErr) {
        checkoutErr.hidden = false;
        checkoutErr.textContent = 'Koppel eerst de value-pack producten in de sectie-instellingen.';
      }
      return;
    }
    checkingOut = true;
    if (checkoutErr) checkoutErr.hidden = true;
    alle('[data-cfp-checkout]', function (b) { b.disabled = true; });
    var codes = [PROEF_CODE, SHIP_CODE].map(function (c) {
      return String(c || '').trim();
    }).filter(Boolean);
    addToCart(gekozen.variant).then(function () {
      var base = shopRoot();
      var goCheckout = function () {
        window.location.href = base + 'checkout';
      };
      if (!codes.length) { goCheckout(); return; }
      return applyDiscount(codes.join(',')).then(goCheckout, function () {
        if (codes.length === 1) {
          window.location.href = base + 'discount/' + encodeURIComponent(codes[0]) + '?redirect=' + encodeURIComponent('/checkout');
          return;
        }
        goCheckout();
      });
    }).catch(function () {
      checkingOut = false;
      alle('[data-cfp-checkout]', function (b) { b.disabled = false; });
      if (checkoutErr) {
        checkoutErr.hidden = false;
        checkoutErr.textContent = 'Afrekenen lukte niet. Probeer het opnieuw of ververs de pagina.';
      }
    });
  }

  alle('[data-cfp-checkout]', function (b) { b.addEventListener('click', onCheckout); });
  if (addonBtn) {
    addonBtn.addEventListener('click', function () {
      if (!ADDON_VARIANT || addonBtn.disabled) return;
      addonBtn.disabled = true;
      addToCart(ADDON_VARIANT).then(function () {
        addonBtn.classList.add('is-added');
        addonBtn.setAttribute('aria-pressed', 'true');
        addonBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l4 4 10-10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>Toegevoegd';
        document.dispatchEvent(new CustomEvent('theme:cart:change'));
      }).catch(function () {
        addonBtn.disabled = false;
      });
    });
  }

  if (typeSwitch) {
    typeSwitch.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cfp-type-btn]');
      if (!b) return;
      var type = b.getAttribute('data-cfp-type-btn');
      root.setAttribute('data-cfp-type', type);
      typeSwitch.querySelectorAll('[data-cfp-type-btn]').forEach(function (x) {
        var on = x === b;
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
        x.classList.toggle('is-active', on);
      });
      gekozen = null;
      if (checkoutErr) checkoutErr.hidden = true;
      rebuildTiles();
      render();
      toonAdvies();
    });
  }

  var bar = document.querySelector('.cfp-bar');
  var buyCheckout = root.querySelector('.cfp-buy [data-cfp-checkout]');
  if (bar && buyCheckout && 'IntersectionObserver' in window) {
    var barObserver = new IntersectionObserver(function (entries) {
      var zichtbaar = entries.some(function (entry) { return entry.isIntersecting; });
      bar.classList.toggle('is-on', !zichtbaar);
      bar.setAttribute('aria-hidden', zichtbaar ? 'true' : 'false');
    }, { threshold: 0.15 });
    barObserver.observe(buyCheckout);
  }

  rebuildTiles();
  render();
})();
